var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTicketGray1614 = function SvgTicketGray1614(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DEE0E1",
    d: "M14.975 6.126a.52.52 0 0 0 .525-.525v-.697c0-3.075-.938-4.013-4.013-4.013H4.512C1.437.891.5 1.83.5 4.904v.352c0 .293.232.525.525.525.675 0 1.222.548 1.222 1.223S1.7 8.219 1.025 8.219a.52.52 0 0 0-.525.525v.352c0 3.075.937 4.013 4.012 4.013h6.975c3.075 0 4.013-.938 4.013-4.013a.52.52 0 0 0-.525-.525 1.223 1.223 0 0 1 0-2.445"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeDasharray: "2 2",
    strokeLinecap: "round",
    d: "M5.3 1.596v10.8"
  })));
};
export default SvgTicketGray1614;